import { render, staticRenderFns } from "./singlepanel.vue?vue&type=template&id=68a1b000&"
import script from "./singlepanel.vue?vue&type=script&lang=js&"
export * from "./singlepanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports